// extracted by mini-css-extract-plugin
export var carrierIcon = "_yj-0";
export var carrierLogo = "_yj-1";
export var detailsSection = "_yj-2";